/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'help': {
    viewBox: '0 0 16 16',
    data: `<g><path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,15c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7C15,11.9,11.9,15,8,15z"/><path d="M7.9,10.5C7.9,10.5,7.9,10.5,7.9,10.5c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.4,0.8,0.8,0.7c0.4,0,0.8-0.4,0.7-0.8c0,0,0,0,0-0.1C8.6,10.7,8.3,10.4,7.9,10.5z"/><path d="M8,4.1C7,4,6,4.7,5.7,5.6l1,0.4C6.9,5.4,7.4,5,8,5c0,0,0,0,0.1,0c0.6,0,1.1,0.5,1.1,1.1c0,1.4-1.9,1.1-1.9,3.7v0.1h1V9.8c0-2.1,2-1.7,2-3.7c0-0.1,0-0.1,0-0.2C10.2,4.8,9.2,3.9,8,4.1z"/></g>`
  }
})
